<input #fileInput type="file" style="display: none;" (change)="onValueChange($event)" [multiple]="multiple" />
<div class="atp-upload-file__container">
  <div class="atp-upload-file__dragndrop-box"
    (click)="maxCount > selectedFiles.length && canClicked && !disabled ? fileInput.click() : ''" (drop)="drop($event)"
    (dragover)="allowDrop($event)">

    <p *ngIf="!disabled && !selectedFiles?.length" class="atp-upload-file__text atp-upload-file__text_tip">
      Переместите
      сюда файл{{maxCount == 1 ? '' : 'ы'}}</p>

    <!-- Валидные файлы -->
    <a class="atp-upload-file__item" [style.cursor]="selectedFile.date ? 'pointer' : 'default'" disabled
      *ngFor="let selectedFile of selectedFiles; let i = index"
      (click)="selectedFile.date ? openFile(selectedFile.id) : ''" (focus)="canClicked = false"
      (blur)="canClicked = true">
      <mat-icon>
        {{getIcon(selectedFile.file ? selectedFile.file.name : selectedFile.name)}}
      </mat-icon>
      <p class="atp-upload-file__text">{{selectedFile.file ? selectedFile.file.name : selectedFile.name}}</p>
      <p class="atp-upload-file__text_size">
        <strong>({{convertSize(selectedFile.file ? selectedFile.file.size : selectedFile.size)}})</strong></p>
      <button *ngIf="!disabled" mat-icon-button type="button" color="warn" class="atp-upload-file__remove-button"
        (click)="removeFile(i,'sf')" (focus)="canClicked = false">
        <mat-icon>delete</mat-icon>
      </button>
      <div class="atp-upload-file__progress-bar">
        <mat-progress-bar *ngIf="!datetimeService.dateToFormatString(selectedFile.date, 'DateTime'); else elseDate"
          mode="determinate" [value]="selectedFile.percentUploading"></mat-progress-bar>
        <ng-template #elseDate>
          <p class="atp-upload-file__text atp-upload-file__text_date">
            {{datetimeService.dateToFormatString(selectedFile.date, 'DateTime')}}</p>
        </ng-template>
      </div>
    </a>

    <!-- Не валидные файлы -->
    <div class="atp-upload-file__item" *ngFor="let notAllowed of notAllowedList; let i = index">
      <mat-icon>
        {{getIcon(notAllowed.fileName)}}
      </mat-icon>
      <p class="atp-upload-file__text">{{notAllowed.fileName}}</p>
      <p class="atp-upload-file__text_size"><strong>({{notAllowed.fileSize}})</strong></p>
      <p class="atp-upload-file__text_error">{{notAllowed.errorMsg}}</p>
      <button mat-icon-button type="button" color="warn" class="atp-upload-file__remove-button"
        (click)="removeFile(i,'na')" (focus)="canClicked = false">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

  </div>
  <div class="atp-upload-file__info" [class.atp-upload-file__info_disabled]="disabled">
    <ng-container *ngIf="!disabled">
      <p class="atp-upload-file__text atp-upload-file__text_info">Максимальный размер файла: {{maxSize}} мб</p>
      <p *ngIf="multiple" class="atp-upload-file__text atp-upload-file__text_info"
        [class.uploading__text_error]="selectedFiles.length >= maxCount">
        Максимальное количество файлов: {{maxCount}}
      </p>
    </ng-container>
  </div>
</div>